import { theme } from '@core/styles'
import styled from '@emotion/styled'
import { FormControl } from 'rsuite'

export const ImagePreviewFormWrapper = styled.div`
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  gap: 20px;
  width: 100%;
`

export const FormControlLabel = styled.div`
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: 700;
`

export const FormControlCheckbox = styled(FormControl)`
  label {
    font-size: 18px;
    font-weight: 700;
  }
  .rs-checkbox-checker {
    padding-top: 0px;
  }
`

export const FormControlHelperText = styled.div`
  font-size: 14px;
  color: ${theme.colors.GRAY_500};
  margin-top: 5px;
  margin-bottom: 10px;
  font-weight: 400;
`

export const FormGroupInline = styled.p`
  display: flex;
  gap: 20px;
`

export const FormGroupFlex = styled.div`
  display: flex;
  margin-bottom: 15px;
`

export const CommentListLayout = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 10px 10px 0px 10px;
  overflow-y: auto;
  height: 300px;
  gap: 10px;
  .title {
    font-size: 18px;
    color: ${theme.colors.SELECTED_BLUE};
  }
  .technical-design-group {
    font-size: 18px;
  }
  .comment {
    font-size: 16px;
  }
  .create-at {
    font-size: 14px;
  }
`
